export const mainFn = (n: string | number) => "main-" + n;
export const mainItemFn = (n: string | number) => "main-item-" + n;
export const layoutFn = (n: string | number) => "layout-" + n;
export const layoutItemFn = (n: string | number) => "layout-item-" + n;
export const flexFn = (n: string | number) => "flex-" + n;
export const flexItemFn = (n: string | number) => "flex-item-" + n;
export const gridFn = (n: string | number) => "grid-" + n;
export const gridItemFn = (n: string | number) => "grid-item-" + n;
export const itemFn = (n: string | number) => "item-" + n;

export function deepClone(object: any) {
  if (typeof object !== "object" || object == null || isFunction(object)) {
    return object;
  }
  const result: any = Array.isArray(object) ? [] : {};
  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      result[key] = deepClone(object[key]);
    }
  }
  return result;
}
export function getTextWidth(text: string, fontSize: any = 14) {
  const _span = document.createElement("span");
  _span.innerText = text;
  _span.style.fontSize = parseInt(fontSize) + "px";
  _span.style.position = "absolute";
  document.body.appendChild(_span);
  const width = _span.offsetWidth;
  document.body.removeChild(_span);
  return width;
}
